import { httpService } from 'src/services';
import { ApiUrl } from 'src/constants';
import { HydraResponse, Response } from 'src/api/hydraResponse';
import { IManageUser, IUsersManageInitial, IUsersManageStatuses } from 'src/typings/usersManage';

export function getUsersFilterInitial(token: string = ''): Promise<Response<IUsersManageInitial>> {
  return httpService.get(`${ApiUrl.getApiUrl().getUsersManageInitial}`, {}, {
    Authorization: `Bearer ${token}`,
  });
}

export function getUsersFilteredData(token: string = '', getParams: string): Promise<HydraResponse<IManageUser[]>> {
  return httpService.get(`${ApiUrl.getApiUrl().getUsersManage}?${getParams}`, {}, {
    Authorization: `Bearer ${token}`,
  });
}

export function putUserStatus(token: string = '', id: string, status: IUsersManageStatuses): Promise<IManageUser> {
  return httpService.put(`${ApiUrl.getApiUrl().changeUserState}`, { users: [{ id, status }] }, {
    Authorization: `Bearer ${token}`,
  });
}
